import FormattedMessage from 'I18n/components/FormattedMessage';
import H2 from 'UIComponents/elements/headings/H2';
import I18n from 'I18n';
import UIButton from 'UIComponents/button/UIButton';
import UIDialogBody from 'UIComponents/dialog/UIDialogBody';
import UIDialogCloseButton from 'UIComponents/dialog/UIDialogCloseButton';
import UIDialogFooter from 'UIComponents/dialog/UIDialogFooter';
import UIDialogHeader from 'UIComponents/dialog/UIDialogHeader';
import UIDialogHeaderImage from 'UIComponents/dialog/UIDialogHeaderImage';
import UIIllustration from 'UIComponents/image/UIIllustration';
import UIModal from 'UIComponents/dialog/UIModal';
import { getMABExperimentIsMasterLive, getMABExperimentVariantsSize
// @ts-expect-error Untyped module
} from 'ContentEditorUI/redux/selectors/mabExperimentSelectors';
import { useDispatch, useSelector } from 'react-redux';
import { useCallback } from 'react';
// @ts-expect-error Untyped module
import { startMABExperiment } from '../redux/actions/mabExperimentActions';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
function getLangKey(key, isLive) {
  const prefix = isLive ? 'alreadyPublished' : 'allDrafts';
  return `pageSettings.mabPublishConfirmModal.${prefix}.${key}`;
}
const MABPublishConfirmModal = ({
  dismissCallback
}) => {
  const mabExperimentIsPrimaryLive = useSelector(getMABExperimentIsMasterLive);
  const numberOfVariants = useSelector(getMABExperimentVariantsSize);
  const dispatch = useDispatch();
  const publishMAB = useCallback(() => {
    dispatch(startMABExperiment());
    dismissCallback();
  }, [dismissCallback, dispatch]);
  return /*#__PURE__*/_jsxs(UIModal, {
    use: "info",
    width: 540,
    centered: true,
    children: [/*#__PURE__*/_jsx(UIDialogHeaderImage, {
      offsetBottom: -36,
      offsetTop: 84,
      children: /*#__PURE__*/_jsx(UIIllustration, {
        alt: I18n.text(getLangKey('illustration', mabExperimentIsPrimaryLive)),
        name: "automated-testing",
        width: 125
      })
    }), /*#__PURE__*/_jsxs(UIDialogHeader, {
      children: [/*#__PURE__*/_jsx(UIDialogCloseButton, {
        onClick: dismissCallback
      }), /*#__PURE__*/_jsx(H2, {
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: getLangKey('header', mabExperimentIsPrimaryLive)
        })
      })]
    }), /*#__PURE__*/_jsx(UIDialogBody, {
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: getLangKey('body', mabExperimentIsPrimaryLive),
        options: {
          count: mabExperimentIsPrimaryLive ? numberOfVariants - 1 : numberOfVariants
        }
      })
    }), /*#__PURE__*/_jsxs(UIDialogFooter, {
      align: "center",
      children: [/*#__PURE__*/_jsx(UIButton, {
        onClick: publishMAB,
        use: "primary",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: getLangKey('confirmLabel', mabExperimentIsPrimaryLive)
        })
      }), /*#__PURE__*/_jsx(UIButton, {
        onClick: dismissCallback,
        use: "secondary",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: getLangKey('dismissLabel', mabExperimentIsPrimaryLive)
        })
      })]
    })]
  });
};
export default MABPublishConfirmModal;